#import "../fragments/preference-center-audience-fragment.graphql"

query GetAudiencesForPreferenceCenter($sort: AudienceSortType!) {
    audiences(first: 10, sort: $sort, audienceTypeFilter: ONLY_PUBLIC) {
        totalCount
        edges {
            cursor
            node {
                ...PreferenceCenterAudience
            }
        }
    }
}
